// extracted by mini-css-extract-plugin
module.exports = {"ul":"UnorderedList_ul__eRGvW","ulQuestion":"UnorderedList_ulQuestion__fMASz","ulCheck":"UnorderedList_ulCheck__1CcNO"};